export const onAnswerPraticeQuestionSuccess = (data, get) => {
  get().setPracticeTotalCount(data.goalId, data.totalCount);
  get().setPracticeMaxScore(data.goalId, data.maxScore);
};
